// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__YjdjJ","empty":"ModalGraph_empty__1iZVU"};